// src/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer className="bg-dark text-white mt-5 p-4 text-center">
      © {new Date().getFullYear()} ROE VIsual US Inc. All rights reserved.
    </footer>
  );
}

export default Footer;
